<template>
  <svg
    width="17"
    height="11"
    viewBox="0 0 17 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2656 5.36719C16.3203 5.47656 16.3477 5.61328 16.3477 5.77734C16.3477 5.91406 16.3203 6.05078 16.2656 6.16016C14.7891 9.05859 11.8359 11 8.5 11C5.13672 11 2.18359 9.05859 0.707031 6.16016C0.652344 6.05078 0.625 5.91406 0.625 5.75C0.625 5.61328 0.652344 5.47656 0.707031 5.36719C2.18359 2.46875 5.13672 0.5 8.5 0.5C11.8359 0.5 14.7891 2.46875 16.2656 5.36719ZM8.5 9.6875V9.71484C10.6602 9.71484 12.4375 7.9375 12.4375 5.77734V5.75C12.4375 3.58984 10.6602 1.8125 8.5 1.8125C6.3125 1.8125 4.5625 3.58984 4.5625 5.75C4.5625 7.9375 6.3125 9.6875 8.5 9.6875ZM8.5 3.125V3.15234C9.94922 3.15234 11.125 4.30078 11.125 5.75C11.125 7.19922 9.94922 8.375 8.5 8.375C7.05078 8.375 5.875 7.19922 5.875 5.75C5.875 5.53125 5.90234 5.28516 5.95703 5.06641C6.17578 5.23047 6.44922 5.3125 6.75 5.3125C7.46094 5.3125 8.03516 4.73828 8.03516 4.02734C8.03516 3.72656 7.95312 3.45312 7.78906 3.23438C8.00781 3.17969 8.25391 3.15234 8.5 3.125Z"
      :fill="props.fill"
    />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  fill: {
    type: String,
    default: '#8ABFDE',
  },
});
</script>
